import { Component, Vue } from 'vue-property-decorator'
import {
  getStudentDetailComplex, queryCourse, changeCourse,
  changeMainTeacher, queryAllMainTeacher, editIdCard, editStudentDetail,
  getTechnologyTaList, createTechnologyTa, editRemark, createQuiteProjectOrder,
  editApplyInfo
} from '@/api'
import { TagsViewModule } from '@/store/modules/tags-view'
import urlBase from '@/utils/urlBase'

@Component({ name: 'student-detail-page' })
export default class StudentDetailPage extends Vue {
  // private uploadHeadUrl = 'http://192.168.0.33:10069/upload/student/headImage' // 头像上传url
  // private uploadResumeUrl = 'http://192.168.0.33:10069/upload/student/resume'
  private uploadHeadUrl = urlBase.eduBaseUrl + 'upload/student/headImage' // 头像上传url
  private uploadResumeUrl = urlBase.eduBaseUrl + 'upload/student/resume'
  private showChangeProjectDialog = false // 换项目的dialog
  private showDeteilProjectDialog = false
  private deteleProjectInfo = null
  private deteleProjectInfoData: any = null
  private showChangeMainTeacherDialog = false // 换主导师的dialog
  private chooseProject: any = {} // 选中的项目
  private remark = ''
  private studentId: any = null
  private replaceProject = null
  private replaceTeacher = null
  private courseList: any = []
  private teacherList: any = []
  private detailType: any = null
  private technologyTaList: any =[]
  private d: any = {
    id: '',
    index: '',
    nameCn: '',
    firstName: '',
    lastName: '',
    idCard: '', // 身份证号
    headerImageUrl: '',
    major: '', // 专业
    email: '',
    phone: null,
    weiXin: '', // 微信号
    resumeUrl: '', // 简历
    applicationForm: '', // 表明表
    gender: null, // 性别
    school: '', // 学校
    grade: '', // 年级
    sources: '', // 来源渠道
    consultingTeacher: '', // 咨询老师
    department: '', // 咨询老师所属部门
    languageGrade: '', // 语言等级
    remark: '', // 备注
    haveFullPaper: null, // 是否包含独立论文
    canEdit: null // 是否可以编辑学员信息
  }

  private course: any =[]
  private loading: any = {}
  private timeval: any = null
  private interactInfo: any = []
  private informationListImg: any = []
  private classApplyInfo: any=[]
  private applySelectList: any = ['空', '有', '无', '待定', '不建议', '需学生自行与教授确认']

  created () {
    // detailType [1：学员列表list详情，2：论文学员详情 ，3：异常学员list详情]
    this.detailType = this.$route.query.detailType
    this.studentId = this.$route.query.id
    this.initstudentPageData()
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('质检总监') < 0 && item.indexOf('质检专员') < 0)) {
      this.echnologyTaList()
    }
  }

  private async initstudentPageData () {
    // 换项目 换导师 退项目 查看/编辑反馈 续报
    const list: any = [{ path: '/workOrder/submitter/create/changeCourse', pathName: 'changeCourse' }, { pathName: 'changeMainTeacher', path: '/workOrder/submitter/create/changeTeacher' },
      { path: '/workOrder/submitter/create/refund', pathName: 'createQuiteProjectOrder' }, { path: '/workOrder/submitter/create/continueJoin', pathName: 'continueJoin' },
      { pathName: 'editNoteSellOrderIdStudent', path: '/evaluation/editNoteForSellOrder' }, { pathName: 'editStudentDetail', path: '/student/edit' }, { pathName: 'editRemark', path: '/sellOrder/edit/remark' }]
    const result: any = await getStudentDetailComplex({ id: this.studentId, pathList: list })
    // 换主导师的权利；
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('运营专员') > -1 || item.indexOf('运营主管') > -1 || item.indexOf('产品总监') > -1 || item.indexOf('销售') > -1)) {
      this.teacherList = await queryAllMainTeacher({})
    }
    this.d = result
    this.course = result.course
    this.interactInfo = result.interactInfo
    const list1: any = JSON.parse(JSON.stringify(this.d.resumeUrlList))
    const resumeUrlList: any = []
    list1.forEach((item: any) => {
      if (item) {
        const url = decodeURI(item)
        const str = url.split('/crm/')[1]
        if (str) {
          const name = str.slice(20)
          const obj = { name: name, url: item }
          resumeUrlList.push(obj)
        }
        if (this.fileExtension(item) === 'png' || this.fileExtension(item) === 'jpg' || this.fileExtension(item) === 'jpeg') {
          this.informationListImg.push(item)
        }
      }
    })
    this.d.resumeUrlList = resumeUrlList
  }

  fileExtension = function (type: any) {
    return type.substring(type.lastIndexOf('.') + 1)
  }

  /**
   * [description] 保存按钮点击
   */
  private async onSaveClick () {
    // 身份证、中文名、所报专业、学员邮箱
    if (!this.d.idCard) {
      this.$message({ message: '学生识别号必填项', type: 'warning' })
      return
    }
    if (!this.d.nameCn) {
      this.$message({ message: '中文名必填项', type: 'warning' })
      return
    }
    if (!this.d.email) {
      this.$message({ message: '学员邮箱必填项', type: 'warning' })
      return
    }
    if (this.$store.state.user.roles.find((item: any) => item.indexOf('产品总监') > -1 || item.indexOf('运营总监') > -1)) {
      // 修改学生识别号的权限
      await editIdCard({ studentId: this.studentId, idCard: this.d.idCard })
    }
    this.d.studentId = this.studentId
    await editStudentDetail(this.d)
    this.$message({ message: '修改成功', type: 'success' })
  }

  /**
   * [description] 续报点击
   */
  private onReSignRroject () {
    this.$router.push({ path: '/student/continue', query: { id: this.studentId } })
  }

  /**
   * [description] 判断是不是小组课
   */
  private isPbl (item: any) {
    const typeId = item.typeId
    return (typeId === 1 || typeId === 6)
  }

  /**
   * [description] 判断是不是1v1课程
   */
  private is1v1 (item: any) {
    const typeId = item.courseTypeId
    return (typeId === 2 || typeId === 3)
  }

  /**
   * [description] 打开换项目的dialog
   */
  private async openCPDialog (item: any) {
    this.chooseProject = item
    this.showChangeProjectDialog = true
  }

  private deteleProject (item: any) {
    this.showDeteilProjectDialog = true
    this.deteleProjectInfoData = item
  }

  private async ondeSureClick () {
    const { error }: any = await createQuiteProjectOrder({ cause: this.deteleProjectInfo, courseId: this.deteleProjectInfoData.courseId, courseType: this.deteleProjectInfoData.courseTypeId, sellOrderId: this.deteleProjectInfoData.sellOrderId, studentId: this.deteleProjectInfoData.studentId })
    if (!error) {
      this.$message({
        type: 'success',
        message: '操作成功!'
      })
      this.showDeteilProjectDialog = false
      this.deteleProjectInfoData = null
      this.deteleProjectInfo = null
    }
    // this.$confirm('此操作将为学生退项目，是否继续', '提示', {
    //   confirmButtonText: '确定',
    //   cancelButtonText: '取消',
    //   type: 'warning',
    //   center: true
    // }).then(async () => {
    //   await createQuiteProjectOrder({ cause: this.deteleProjectInfo, courseId: this.deteleProjectInfoData.courseId, courseType: this.deteleProjectInfoData.courseTypeId, sellOrderId: this.deteleProjectInfoData.sellOrderId, studentId: this.deteleProjectInfoData.studentId })
    //   this.$message({
    //     type: 'success',
    //     message: '操作成功!'
    //   })
    // })
  }

  private async changeTimeval () {
    this.replaceProject = null
    this.courseList = await queryCourse({ courseType: this.chooseProject.courseTypeId, schoolBeginsChangeCourse: this.timeval })
  }

  /**
   * [description] 打开换主导师的dialog
   */
  private openCMTDialog (item: any) {
    this.chooseProject = item
    this.showChangeMainTeacherDialog = true
  }

  /**
   * [description] 换项目确定操作
   */
  private async onCPSureClick () {
    await changeCourse({
      oldCourseId: this.chooseProject.courseId,
      newCourseId: this.replaceProject,
      sellOrderId: this.chooseProject.sellOrderId,
      remark: this.remark,
      studentId: this.studentId
    })
    this.$message({ message: '换项目成功', type: 'success' })
    this.chooseProject = {}
    this.remark = ''
    this.showChangeProjectDialog = false
    this.replaceProject = null
    this.timeval = null
    this.initstudentPageData()
  }

  /**
   * [description] 换导师操作
   */
  private async onCTSureClick () {
    await changeMainTeacher({
      courseId: this.chooseProject.courseId,
      sellOrderId: this.chooseProject.sellOrderId,
      newTeacherId: String(this.replaceTeacher),
      remark: this.remark,
      studentId: this.studentId
    })
    this.$message({ message: '换导师成功', type: 'success' })
    this.chooseProject = {}
    this.remark = ''
    this.showChangeProjectDialog = false
    this.initstudentPageData()
    this.$router.go(-1)
    TagsViewModule.delView(this.$route)
  }

  /**
   * [description] 科研助教导师list
   */
  private async echnologyTaList () {
    const list = await getTechnologyTaList({})
    this.technologyTaList = list
  }

  /**
   * [description] 修改科研助教导师
   */
  private async edittechnologyTA (item: any) {
    await createTechnologyTa({ classId: item.classId, technologyId: item.technologyTAId })
    this.$message({ type: 'success', message: '分配科研助教成功' })
  }

  /**
   * [description] 删除头像
   */
  private onDeleteHeadImage () {
    this.d.headerImageUrl = ''
  }

  // 删除简历
  private onDeleteResume () {
    this.d.resumeUrl = ''
  }

  // 头像上传回调函数
  private handleAvatarSuccess (res: any, file: any) {
    this.d.headerImageUrl = res.data
    this.$message({ type: 'success', message: '上传头像成功' })
    this.loading.close()
  }

  // 简历上传回调函数
  private handleResumeSuccess (res: any) {
    this.d.resumeUrl = res.data
    this.$message({ type: 'success', message: '上传简历成功' })
    this.loading.close()
  }

  // 上传中提示
  private handleApplicationFormProgress () {
    this.loading = this.$loading({
      lock: true,
      text: '上传中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }

  // 报名表上传失败回调函数
  private handleApplicationFormError () {
    this.$message({ message: '上传失败，请重新上传', type: 'error' })
    this.loading.close()
  }

  // 学员异常详情
  private async seeAbnormalDeatil (item: any) {
    this.$router.push({ path: '/approve/anomaly', query: { id: item.workOrderId, action: 'look' } })
  }

  private addFeedback (type: any, item: any, item1: any) {
    console.log('addFeedback item: ', item)
    // type 1。新增反馈 2。修改反馈
    if (item1) { // 换班级后重新分配的学员
      this.$router.push({ path: '/student/feedback', query: { applyDetail: item.applyDetail || '空', applyType: item.applyType, type: type, studentName: this.d.nameCn, studentId: this.$route.query.id, sellOrderId: item.sellOrderId, classId: item1.classId, isCurrentClass: item1.isCurrentClass, createStr: item1.createStr } })
    } else {
      this.$router.push({ path: '/student/feedback', query: { applyDetail: item.applyDetail || '空', applyType: item.applyType, type: type, studentName: this.d.nameCn, studentId: this.$route.query.id, sellOrderId: item.sellOrderId, classId: item.classId } })
    }
  }

  private addlunFeedback (type: any, item: any) {
    if (Number(item.templateType) === 3) {
      this.$router.push({ path: '/student/studentLunwenDetail1', query: { applyDetail: item.applyDetail || '空', applyType: item.applyType, studentId: this.$route.query.id, sellOrderId: item.sellOrderId, classId: item.classId } })
    } else {
      // 查看反馈
      this.$router.push({ path: '/student/studentLunwenDetail', query: { applyDetail: item.applyDetail || '空', applyType: item.applyType, studentId: this.$route.query.id, sellOrderId: item.sellOrderId, classId: item.classId } })
    }
  }

  private toKb () {
    this.$router.push({ path: '/student/schedule', query: { studentId: this.d.id, studentnameCn: this.d.nameCn } })
  }

  private async changeRemark (item: any) {
    await editRemark({ sellOrderId: item.sellOrderId, remark: item.remark })
    this.$message({ type: 'success', message: '修改备注成功' })
  }

  private async changeApplyType (item: any) {
    console.log('item: ', item)
    await editApplyInfo(item)
    this.$message({ type: 'success', message: '修改备注成功' })
  }
}
